module.exports = __webpack_public_path__ + "img/icon-white-24.7a6a4eff.svg";